//Manage form for providers and publishers.
import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import ClearIcon from "@material-ui/icons/Clear";
import { textFieldValid } from "../../helpers/validation";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import CheckIcon from "@material-ui/icons/Check";
import { Prompt } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import { useFormTouched } from "../../hooks/useFormTouched";
import HelpIcon from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";
import { Domain } from "../../services/Domain";
import AutocompleteSelect from "../../components/AutoCompleteSelect/AutoCompleteSelect";

const Form = ({ editing, onFormSubmit, initialValues, handleCancel, type }) => {
    const [name, setName] = useState(initialValues.name);
    const [default_domain, setDefaultDomain] = useState(initialValues.default_domain || "");
    const [details, setDetails] = useState(initialValues.details);
    const [pid, setPID] = useState(initialValues.id);
    const [status, setStatus] = useState(initialValues.status);
    const [showPrompt, setShowPrompt] = useState(true);
    const [open, setOpen] = useState(false);
    const [csv_source_identifier, setCsvCol] = useState("");
    const [link_source_identifier, setLinkCol] = useState("");
    const [advertiser_code, setAdvertiserCode] = useState("");
    const [reports_gross_revenue, setReportsGrossRevenue] = useState(
        initialValues.reports_gross_revenue || false
    );
    const [revenue_share_percentage, setRevenueSharePercentage] = useState(
        initialValues.revenue_share_percentage || 0
    );
    const [domains, setDomains] = useState([]);
    //const [api_source_identifier, setApiCol] = useState("");
    const [display_in_upload_screen, setDisplayUploadScreen] = useState(false);

    const [fieldErrors, setFieldErrors] = useState({
        name: false,
        details: false,
        csv_source_identifier: false,
        // api_source_identifier: false,
        link_source_identifier: false,
        advertiser_code: false
    });

    const { formTouched, handleFormTouched, clearFormTouched } = useFormTouched({
        cleanupFunction: () => { }
    });
    // console.log({ domains })


    useEffect(() => {
        setName(initialValues.name);
        setDefaultDomain(initialValues.default_domain || "");
        setDetails(initialValues.details);
        setPID(initialValues.id);
        setStatus(initialValues.status);
        if (type === "provider") {
            setDisplayUploadScreen(initialValues.display_in_upload_screen);
            setCsvCol(initialValues?.csv_source_identifier);
            setLinkCol(initialValues?.link_source_identifier);
            setAdvertiserCode(initialValues?.advertiser_code);
            setReportsGrossRevenue(initialValues?.reports_gross_revenue);
            setRevenueSharePercentage(initialValues?.revenue_share_percentage);
        }
        if (type === "publisher") {
            Domain.fetchDomainList({ order_by: "domain", order_direction: "ASC" })
                .then((res) => {
                    if (res.success) {
                        const domains = res.data.domains.rows.map((domain) => ({
                            label: domain.domain,
                            value: domain.domain
                        }))
                        setDomains(domains);
                    } else {
                        throw new Error(JSON.stringify(res.error));
                    }
                }
                )
                .catch((err) => {
                    console.trace(err.message);
                    toastr.error("Error", "Failed to fetch domains");
                })
        }
    }, [initialValues, type]);

    const validateForm = () => {
        let isValid = true;
        if (!textFieldValid(name)) {
            setFieldErrors({ ...fieldErrors, name: true });
            isValid = false;
            return;
        }
        return isValid;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        clearFormTouched();
        setShowPrompt(false);
        //changing status to null in case of empty string
        let detailsValue = details;
        if (!textFieldValid(details)) {
            detailsValue = null;
        }
        const data = {
            name: name.trim(),
            details: detailsValue,
            status
        };
        if (type === "provider") {
            data["display_in_upload_screen"] = display_in_upload_screen;
            data["csv_source_identifier"] =
                csv_source_identifier?.length > 0 ? csv_source_identifier : null;
            data["reports_gross_revenue"] = reports_gross_revenue;
            data["revenue_share_percentage"] = revenue_share_percentage;
            data["link_source_identifier"] =
                link_source_identifier?.length > 0 ? link_source_identifier : null;
            data["advertiser_code"] =
                advertiser_code?.length > 0 ? advertiser_code : null;
        }
        if (type === "publisher") {
            data["default_domain"] = default_domain || null;
        }

        if (editing) {
            onFormSubmit(pid, data);
        } else {
            onFormSubmit(data);
        }
    };

    let submitButton = (
        <Button
            color="primary"
            onClick={(e) => handleSubmit(e)}
            variant="contained"
            size="medium"
            startIcon={<CheckIcon />}
            type="submit"
        >
            {" "}
            Save
        </Button>
    );

    const disableStatus = () => {
        setStatus("inactive");
    };

    const handleEditCheckboxChange = (e) => {
        if (type === "provider" && status === "active") {
            if (parseInt(initialValues.no_of_rules) > 0) {
                toastr.info(
                    "Info",
                    "Cannot change status of advertiser that are being used in targeting rules."
                );
                return;
            }
        }

        if (type === "publisher" && status === "active") {
            if (parseInt(initialValues.no_of_targetings) > 0) {
                setOpen(true);
                return;
            }
        }
        e.target.checked ? setStatus("active") : setStatus("inactive");
        handleFormTouched();
    };

    const handleCheckBoxChange = (e) => {
        e.target.checked ? setStatus("active") : setStatus("inactive");
        handleFormTouched();
    };

    const handleUploadCSVChange = (e) => {
        setDisplayUploadScreen(e.target.checked);
        handleFormTouched();
    };
    const statusModal = (
        <ConfirmBox
            message={`This publisher has associated targetings.Are you sure?`}
            confirmAction={() => {
                handleFormTouched();
                disableStatus();
                setOpen(false);
            }}
            denyAction={() => setOpen(false)}
        ></ConfirmBox>
    );



    return (
        <>
            <form>
                <div class="advertiser_id_and_statuses" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>
                    {editing && (
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                            <h3 className="dark-grey-text">PID</h3>
                            <TextField
                                variant="filled"
                                margin="normal"
                                name="pid"
                                value={pid}
                                error={fieldErrors.pid}
                                onChange={(e) => {
                                    handleFormTouched();
                                    setPID(e.target.value);
                                }}
                                disabled
                            />
                        </div>
                    )}

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
                        {type === "provider" && (
                            <>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            onChange={handleUploadCSVChange}
                                            name="display_in_csv_upload"
                                            color="primary"
                                            checked={display_in_upload_screen}
                                        />
                                    }
                                    label="Display In Csv Upload"
                                />
                            </>
                        )}
                        <h3 className="dark-grey-text">Status</h3>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={
                                        editing ? handleEditCheckboxChange : handleCheckBoxChange
                                    }
                                    name="status"
                                    color="primary"
                                    checked={status === "active" ? true : false}
                                />
                            }
                            label="Active"
                        />
                    </div>
                </div>

                <div class="name_and_details" style={{ border: "1px solid lightgray", padding: "10px", margin: "10px", maxWidth: "500px", display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>
                    <FormControl fullWidth>
                        <TextField
                            variant="standard"
                            margin="normal"
                            label="Name"
                            name="name"
                            value={name}
                            error={fieldErrors.name}
                            onChange={(e) => {
                                handleFormTouched();
                                setName(e.target.value);
                                setFieldErrors({ ...fieldErrors, name: false });
                            }}
                            autoFocus
                            placeholder="Enter Name"
                        />
                        {fieldErrors.name && (
                            <FormHelperText>Name is Required</FormHelperText>
                        )}
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            label="Details"
                            name="details"
                            multiline
                            variant="standard"
                            value={details}
                            error={fieldErrors.details}
                            onChange={(e) => {
                                handleFormTouched();
                                setDetails(e.target.value);
                                setFieldErrors({ ...fieldErrors, details: false });
                            }}
                            minRows={4}
                            maxRows={10}
                            fullWidth
                        />
                        {fieldErrors.details && (
                            <FormHelperText color="secondary">
                                Please enter details.
                            </FormHelperText>
                        )}
                    </FormControl>
                </div>

                {type === "publisher" && (
                    <div class="name_and_details" style={{ padding: "10px", margin: "10px", maxWidth: "500px", display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>

                        <FormControl fullWidth style={{ marginTop: "1rem" }}>
                            <AutocompleteSelect
                                variant="outlined"
                                margin="normal"
                                name="default_domain"
                                selected={default_domain}
                                data={domains}
                                handleChange={(value) => {
                                    handleFormTouched();
                                    setDefaultDomain(value);
                                    setFieldErrors({ ...fieldErrors, default_domain: false });
                                }}
                                label={"Default domain"}
                                showValueInLabel={false}
                                enableMultiple={false}
                                withDotsForStatus={false}
                                error={fieldErrors.default_domain}
                            />
                            {fieldErrors.default_domain && (
                                <FormHelperText>
                                    <span className="error-text">
                                        Select a domain
                                    </span>
                                </FormHelperText>
                            )}
                        </FormControl>
                    </div>
                )}

                {type === "provider" && (
                    <div class="reports_gross_revenue?" style={{ border: "1px solid lightgray", padding: "10px", margin: "10px", maxWidth: "500px", marginTop: "20px", display: "flex", flexDirection: "row", alignItems: "center", gap: "20px" }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={(e) => setReportsGrossRevenue(e.target.checked)}
                                    name="reports_gross_revenue"
                                    color="primary"
                                    checked={reports_gross_revenue ? true : false}
                                />
                            }
                            label="Reports gross revenue"
                        />
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                            <FormControl fullWidth>
                                <TextField
                                    variant="standard"
                                    margin="normal"
                                    label="Our revenue share"
                                    name="revenue_share_percentage"
                                    value={revenue_share_percentage}
                                    error={fieldErrors.revenue_share_percentage}
                                    disabled={!reports_gross_revenue}
                                    onChange={(e) => {
                                        handleFormTouched();
                                        setRevenueSharePercentage(e.target.value);
                                        setFieldErrors({
                                            ...fieldErrors,
                                            revenue_share_percentage: false
                                        });
                                    }}
                                    placeholder="Enter revenue share percentage"
                                />
                                {fieldErrors.revenue_share_percentage && (
                                    <FormHelperText color="secondary">
                                        Please enter revenue share percentage
                                    </FormHelperText>
                                )}
                            </FormControl>
                            <Tooltip
                                title={
                                    "Revenue share percentage is required when advertiser is reporting gross revenue."
                                }
                            >
                                <div className="gray-icon ">
                                    <HelpIcon fontSize="small" />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                )}
                {type === "provider" && (
                    <div class="additional_fields" style={{ border: "1px solid lightgray", padding: "10px", margin: "10px", marginTop: "20px", maxWidth: "500px", display: "flex", flexDirection: "column", gap: "20px" }}>
                        <React.Fragment>
                            <div className="flex-box align-items-bottom">
                                <FormControl fullWidth>
                                    <TextField
                                        variant="standard"
                                        margin="normal"
                                        label="CSV & API Source Identifier"
                                        name="csv_source_identifier"
                                        value={csv_source_identifier}
                                        error={fieldErrors.csv_source_identifier}
                                        onChange={(e) => {
                                            handleFormTouched();
                                            setCsvCol(e.target.value);
                                            setFieldErrors({
                                                ...fieldErrors,
                                                csv_source_identifier: false
                                            });
                                        }}
                                        placeholder="Enter Source Identifier"
                                    />
                                    {fieldErrors.csv_source_identifier && (
                                        <FormHelperText color="secondary">
                                            Please enter CSV(Column name)/API source identifier
                                        </FormHelperText>
                                    )}
                                </FormControl>
                                <Tooltip title={"Column Name (CSV)/API source identifier (API)"}>
                                    <div className="gray-icon ">
                                        <HelpIcon fontSize="small" />
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="flex-box align-items-bottom">
                                <FormControl fullWidth>
                                    <TextField
                                        variant="standard"
                                        margin="normal"
                                        label="Link Source Identifier"
                                        name="link_source_identifier"
                                        value={link_source_identifier}
                                        error={fieldErrors.link_source_identifier}
                                        onChange={(e) => {
                                            handleFormTouched();
                                            setLinkCol(e.target.value);
                                            setFieldErrors({
                                                ...fieldErrors,
                                                link_source_identifier: false
                                            });
                                        }}
                                        placeholder="Enter Source Identifier"
                                    />
                                    {fieldErrors.link_source_identifier && (
                                        <FormHelperText color="secondary">
                                            Please enter link source identifier
                                        </FormHelperText>
                                    )}
                                </FormControl>
                                <Tooltip title={"Name of the parameter in the link"}>
                                    <div className="gray-icon ">
                                        <HelpIcon fontSize="small" />
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="flex-box align-items-bottom">
                                <FormControl fullWidth>
                                    <TextField
                                        variant="standard"
                                        margin="normal"
                                        label="Advertiser Code"
                                        name="advertiser_code"
                                        value={advertiser_code}
                                        error={fieldErrors.advertiser_code}
                                        onChange={(e) => {
                                            handleFormTouched();
                                            setAdvertiserCode(e.target.value);
                                            setFieldErrors({
                                                ...fieldErrors,
                                                advertiser_code: false
                                            });
                                        }}
                                        placeholder="Enter advertiser code"
                                    />
                                    {fieldErrors.advertiser_code && (
                                        <FormHelperText color="secondary">
                                            Please enter advertiser code
                                        </FormHelperText>
                                    )}
                                </FormControl>
                                <Tooltip
                                    title={
                                        "Unique identifier for advertiser. Please do not change this unless you're sure for it."
                                    }
                                >
                                    <div className="gray-icon ">
                                        <HelpIcon fontSize="small" />
                                    </div>
                                </Tooltip>
                            </div>
                        </React.Fragment>
                    </div>
                )}
                <div class="form_controls" style={{ marginTop: "20px", display: "flex", flexDirection: "row", justifyContent: "center", gap: "10px", }}>
                    {submitButton}
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        size="medium"
                        color="secondary"
                        startIcon={<ClearIcon />}
                    >
                        Cancel
                    </Button>
                </div>
                {open && statusModal}
            </form>
            <Prompt
                when={showPrompt && formTouched.current}
                message="Are you sure you want to leave?"
            />
        </>
    );



};

export default Form;
